module.exports = __webpack_public_path__ + "img/logo -shadwo-padel.772dac3a.png";